import React from "react";

const MainApp = ({ children }) => {
  return <div>{children}</div>;
};

export default MainApp;



// WEBPACK FOOTER //
// ./src/component/MainApp/MainApp.jsx